export default [
    {
        path: "/user-management/list-users",
        name: "list-users",
        meta: {title: "list-users", authRequired: true},
        component: () => import("../views/user-management/list-users"),
    },
    {
        path: "/user-management/list-roles",
        name: "list-roles",
        meta: {title: "list-roles", authRequired: true},
        component: () => import("../views/user-management/list-roles"),
    },
    {
        path: "/user-management/list-permissions",
        name: "list-permissions",
        meta: {title: "list-permissions", authRequired: true},
        component: () => import("../views/user-management/list-permissions"),
    }
]